<template>
  <div class="chartNum">
    <div class="box-item">
      <li
          :class="{ 'number-item': !isNaN(item), 'comma-item': isNaN(item) }"
          v-for="(item, index) in displayNum"
          :key="index"
      >
        <span v-if="!isNaN(item)">
          <i class="num-point" ref="numberItem">0123456789</i>
        </span>
        <span v-else>{{ item }}</span>
      </li>
    </div>
  </div>
</template>

<script>
export default {
  name: 'chartNum',
  data() {
    return {
      displayNum: [], // 显示用的数字数组
    };
  },
  props: {
    scrollNum: {
      type: [String, Number],
      default: '0',
      validator: value => !isNaN(Number(value))
    },
  },
  watch: {
    scrollNum: {
      immediate: true,
      handler(val) {
        this.formatNumber(val);
        this.$nextTick(() => {
          this.setNumberTransform();
        });
      },
    },
  },
  methods: {
    // 格式化数字（确保最多3位小数，整数不显示小数）
    formatNumber(num) {
      const numberValue = Number(num);
      if (isNaN(numberValue)) {
        this.displayNum = [0];
        return;
      }

      // 处理整数情况
      if (Number.isInteger(numberValue)) {
        // 直接转为字符数组，保留原始数字顺序
        this.displayNum = String(numberValue).split('').map(char => {
          // 确保0被正确转换为数字0，而不是其他值
          return char === '0' ? 0 : Number(char);
        });
        return;
      }

      // 处理小数情况（保持原有逻辑）
      let fixed = numberValue.toFixed(3);
      let formattedStr = fixed.replace(/(\.\d*?)0+$/, '$1').replace(/\.$/, '');
      const parts = formattedStr.split('.');
      formattedStr = parts.join('.');

      this.displayNum = formattedStr.split('').map(char => {
        return char === '.' ? '.' : Number(char);
      });

    },

    setNumberTransform() {
      // 确保获取正确的DOM节点顺序
      this.$nextTick(() => {
        const numberElements = this.$el.querySelectorAll('.num-point');
        const numbers = this.displayNum.filter(item => !isNaN(item));

        numbers.forEach((num, index) => {
          const elem = numberElements[index];
          if (elem) {
            const position = -num * 10;
            elem.style.transform = `translate(-50%, ${position}%)`;
          }
        });
      });
    }
  },
};
</script>

<style scoped lang="less">
/* 保持原有样式不变 */
.chartNum {
  height: 100%;
}

.box-item {
  height: 100px;
  font-size: 54px;
  line-height: 41px;
  text-align: center;
  list-style: none;
  color: #2d7cff;
  display: flex;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.number-item {
  background: url('~@/assets/recycling/echartsMap/numBackgrounds.svg') no-repeat;
  width: 35px;
  height: 45px;
  font-weight: 700;
  margin-right: 12px;
  font-size: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;

  & > span {
    position: relative;
    display: inline-block;
    width: 100%;
    height: 100%;
    writing-mode: vertical-rl;
    text-orientation: upright;
    overflow: hidden;

    & > i {
      font-style: normal;
      position: absolute;
      top: 7px;
      left: 60%;
      transform: translate(-50%, 0);
      transition: transform 1s ease-in-out;
      letter-spacing: 10px;
      width: 35px;
    }
  }
}

.comma-item {
  width: 35px;
  height: 45px;
  font-weight: 700;
  margin-right: 12px;
  font-size: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  transform: translateY(2px);
}

.number-item:last-child,
.comma-item:last-child {
  margin-right: 0;
}
</style>
